document.addEventListener('DOMContentLoaded', () => {
  if (typeof mmAnnouncementBar === 'function') mmAnnouncementBar();
  if (typeof mmCartDrawer     === 'function') mmCartDrawer();
  if (typeof mmBundlePicker   === 'function') mmBundlePicker();
  if (typeof mmFilterPills    === 'function') mmFilterPills();
});

function mmAnnouncementBar() {
  const msgs = document.querySelectorAll('.mm-announce__msg');
  const dots = document.querySelectorAll('.mm-announce__dot');
  if (msgs.length <= 1) return;

  let current = 0;
  setInterval(() => {
    msgs[current].classList.remove('is-active');
    dots[current].classList.remove('is-active');
    current = (current + 1) % msgs.length;
    msgs[current].classList.add('is-active');
    dots[current].classList.add('is-active');
  }, 3000);
}

async function mmAddToCart(btn, variantId) {
  btn.disabled = true;
  btn.textContent = 'Adding…';
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    btn.textContent = 'Added ✓';
    if (typeof mmCartDrawerOpen === 'function') mmCartDrawerOpen();
    setTimeout(() => {
      btn.textContent = '+ Add to Cart';
      btn.disabled = false;
    }, 2000);
  } catch (e) {
    btn.textContent = 'Error — try again';
    btn.disabled = false;
  }
}

function mmBundlePicker() {
  const grid   = document.getElementById('mm-bundle-grid');
  const fill   = document.getElementById('mm-bundle-fill');
  const label  = document.getElementById('mm-bundle-label');
  const cta    = document.getElementById('mm-bundle-cta');
  if (!grid) return;

  const TARGET = 3;

  grid.querySelectorAll('.mm-bundle__item').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('is-selected');
      btn.setAttribute('aria-pressed', btn.classList.contains('is-selected') ? 'true' : 'false');
      updateBundleState();
    });
  });

  function updateBundleState() {
    const selected = grid.querySelectorAll('.mm-bundle__item.is-selected');
    const count    = selected.length;
    const pct      = Math.min((count / TARGET) * 100, 100);

    fill.style.width = pct + '%';

    if (count < TARGET) {
      label.innerHTML = `${count} of ${TARGET} selected — select ${TARGET - count} more`;
      cta.disabled = true;
    } else {
      label.innerHTML = `${TARGET} of ${TARGET} selected — <strong>15% off applied!</strong>`;
      cta.disabled = false;
    }
  }
}

async function mmBundleAddToCart() {
  const grid = document.getElementById('mm-bundle-grid');
  const cta  = document.getElementById('mm-bundle-cta');
  const selected = grid.querySelectorAll('.mm-bundle__item.is-selected');
  if (selected.length < 3) return;

  cta.disabled = true;
  cta.textContent = 'Adding…';

  const items = Array.from(selected).map(btn => ({
    id: parseInt(btn.dataset.variantId, 10),
    quantity: 1
  }));

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    cta.textContent = 'Added to cart ✓';
    if (typeof mmCartDrawerOpen === 'function') mmCartDrawerOpen();
    setTimeout(() => {
      cta.textContent = 'Add Bundle to Cart — Save 15% →';
      cta.disabled = false;
      grid.querySelectorAll('.mm-bundle__item.is-selected').forEach(b => b.classList.remove('is-selected'));
      document.getElementById('mm-bundle-fill').style.width = '0%';
      document.getElementById('mm-bundle-label').textContent = 'Select 3 stickers to save 15%';
    }, 2500);
  } catch (e) {
    cta.textContent = 'Error — try again';
    cta.disabled = false;
  }
}

function mmEscapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function mmCartDrawer() {
  const drawer  = document.getElementById('mm-cart-drawer');
  const overlay = document.getElementById('mm-cart-overlay');
  if (!drawer) return;

  // Wire cart icons to open drawer
  document.querySelectorAll('[href="/cart"], .cart-icon, .header__icon--cart')
    .forEach(el => {
      el.addEventListener('click', e => { e.preventDefault(); mmCartDrawerOpen(); });
    });
}

function mmCartDrawerOpen() {
  const drawer  = document.getElementById('mm-cart-drawer');
  const overlay = document.getElementById('mm-cart-overlay');
  if (!drawer) return;
  drawer.classList.add('is-open');
  overlay.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  mmCartDrawerRefresh();
  const closeBtn = drawer.querySelector('.mm-cart-drawer__close');
  if (closeBtn) setTimeout(() => closeBtn.focus(), 50);
}

function mmCartDrawerClose() {
  const drawer  = document.getElementById('mm-cart-drawer');
  const overlay = document.getElementById('mm-cart-overlay');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  overlay.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
}

async function mmCartDrawerRefresh() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    mmCartDrawerRender(cart);
  } catch (e) {
    console.error('Cart refresh failed', e);
  }
}

function mmCartDrawerRender(cart) {
  const countEl    = document.getElementById('mm-cart-count');
  const itemsEl    = document.getElementById('mm-cart-items');
  const subtotalEl = document.getElementById('mm-cart-subtotal');
  const shippingEl = document.getElementById('mm-cart-shipping-note');

  countEl.textContent    = cart.item_count;
  subtotalEl.textContent = (cart.total_price / 100).toLocaleString('en-SG', { style: 'currency', currency: 'SGD' });

  const threshold = 5000;
  const remaining = Math.max(0, threshold - cart.total_price);
  if (remaining > 0) {
    shippingEl.textContent = `Add $${(remaining / 100).toFixed(2)} more for free shipping`;
  } else {
    shippingEl.textContent = 'You have free shipping!';
  }

  // Line items
  if (cart.items.length === 0) {
    itemsEl.innerHTML = '<p class="mm-cart-drawer__empty">Your cart is empty.</p>';
    return;
  }

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="mm-cart-item">
      <img class="mm-cart-item__img"
           src="${item.image ? item.image : ''}"
           alt="${item.title.replace(/"/g, '&quot;')}"
           loading="lazy">
      <div class="mm-cart-item__info">
        <div class="mm-cart-item__name">${mmEscapeHtml(item.product_title)}</div>
        ${item.variant_title !== 'Default Title' ? `<div class="mm-cart-item__variant">${mmEscapeHtml(item.variant_title)}</div>` : ''}
        <div class="mm-cart-item__qty">
          <button class="mm-qty-btn" onclick="mmCartUpdateQty('${item.key}', ${item.quantity - 1})" aria-label="Decrease quantity">−</button>
          <span>${item.quantity}</span>
          <button class="mm-qty-btn" onclick="mmCartUpdateQty('${item.key}', ${item.quantity + 1})" aria-label="Increase quantity">+</button>
        </div>
      </div>
      <div class="mm-cart-item__price">${(item.line_price / 100).toLocaleString('en-SG', { style: 'currency', currency: 'SGD' })}</div>
    </div>
  `).join('');
}

async function mmCartUpdateQty(lineKey, newQty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: Math.max(0, newQty) })
  });
  mmCartDrawerRefresh();
}
